import {Routes} from '@angular/router'
import {LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LandingComponent} from './common/login/landing.component'

export default [
  {
    path: '',
    children: [
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'landing',
        component: LandingComponent
      },
      {
        path: 'main',
        loadChildren: () => import('./main/main-routes')
      },
      {
        path: 'bindings',
        loadChildren: () => import('./bindings/bindings-routes')
      },
      {
        path: 'ondemand',
        loadChildren: () => import('./ondemand/ondemand-routes')
      },
      {
        path: 'discount',
        loadChildren: () => import('./discount/discount-routes')
      },
      {
        path: 'error',
        loadChildren: () => import('./error/error-routes')
      },
      {
        path: '**',
        redirectTo: 'landing'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }
] satisfies Routes
